import { render } from "./AppHeaderAlternative.vue?vue&type=template&id=4f4c6ba5&scoped=true"
import script from "./AppHeaderAlternative.vue?vue&type=script&lang=js"
export * from "./AppHeaderAlternative.vue?vue&type=script&lang=js"

import "./AppHeaderAlternative.vue?vue&type=style&index=0&id=4f4c6ba5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4c6ba5"]])

export default __exports__